export default __webpack_public_path__ + "static/media/hand.e14e852a.svg";